/* Homepage browsing only. Product-page bundle and cart behavior remains in the existing theme. */
(function () {
  'use strict';
  if (window.psHomeShoppingLoaded) return;
  window.psHomeShoppingLoaded = true;
  var homeKey = 'ps-home-context-v1';

  function readHome() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(homeKey));
      return saved && Date.now() - saved.savedAt < 86400000 ? saved : null;
    } catch (_) { return null; }
  }
  function saveHome(root) {
    if (!root.querySelector('[data-ps-product-grid]')) return;
    var selected = root.querySelector('[data-ps-filter][aria-pressed="true"]');
    var variants = {};
    root.querySelectorAll('[data-product-handle] [data-ps-variant-select]').forEach(function (select) {
      variants[select.closest('[data-product-handle]').dataset.productHandle] = select.value;
    });
    try {
      sessionStorage.setItem(homeKey, JSON.stringify({ category: selected ? selected.dataset.psFilter : 'bestsellers', variants: variants, scrollY: window.scrollY, url: location.href, savedAt: Date.now() }));
    } catch (_) {}
  }

  function selectCategory(root, category) {
    var grid = root.querySelector('[data-ps-product-grid]');
    var filters = Array.from(root.querySelectorAll('[data-ps-filter]'));
    var selected = filters.find(function (item) { return item.dataset.psFilter === category; });
    if (!grid || !selected) return false;
    var count = 0;
    grid.querySelectorAll('.ps-home__product').forEach(function (card) {
      card.hidden = !(card.dataset.psCategories || '').split(' ').includes(category);
      if (!card.hidden) count += 1;
    });
    filters.forEach(function (item) {
      var active = item === selected;
      item.classList.toggle('ps-home__category--active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    root.querySelectorAll('[data-ps-preworkout-comparison], [data-ps-preworkout-guide]').forEach(function (comparison) {
      comparison.hidden = category !== 'pre-workouts';
    });
    var status = root.querySelector('[data-ps-filter-status]');
    if (status) status.textContent = count + ' products · ' + selected.textContent.trim();
    root.dataset.psSelectedCategory = category;
    return true;
  }

  function init(scope) {
    var roots = Array.from(scope.querySelectorAll('.ps-home'));
    if (scope.matches && scope.matches('.ps-home')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (root.hasAttribute('data-ps-shopping-ready')) return;
      root.setAttribute('data-ps-shopping-ready', '');
      var initialStatus = root.querySelector('[data-ps-filter-status]');
      if (initialStatus) initialStatus.textContent = root.querySelectorAll('[data-ps-product-grid] .ps-home__product:not([hidden])').length + ' products · Bestsellers';

      root.addEventListener('click', function (event) {
        var control = event.target.closest('[data-ps-filter], [data-ps-select-category]');
        if (!control || !root.contains(control) || event.defaultPrevented) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        if (!selectCategory(root, control.dataset.psFilter || control.dataset.psSelectCategory)) return;
        event.preventDefault();
        saveHome(root);
        if (control.hasAttribute('data-ps-select-category')) {
          var destination = root.querySelector('.ps-home__shop');
          if (destination) {
            destination.setAttribute('tabindex', '-1');
            destination.focus({ preventScroll: true });
            destination.scrollIntoView({ behavior: 'auto', block: 'start' });
          }
        }
      });

      root.addEventListener('change', function (event) {
        var select = event.target.closest('[data-ps-variant-select]');
        if (!select || !root.contains(select)) return;
        var sourceCard = select.closest('[data-product-handle]');
        document.querySelectorAll('.ps-home [data-product-handle]').forEach(function (card) {
          if (card.dataset.productHandle !== sourceCard.dataset.productHandle || !card.querySelector('[data-ps-variant-select]')) return;
          var template = Array.from(card.querySelectorAll('template[data-ps-variant]')).find(function (item) { return item.dataset.psVariant === select.value; });
          if (!template) return;
          template.content.querySelectorAll('[data-ps-part]').forEach(function (part) {
            var target = card.querySelector('[data-ps-part="' + part.dataset.psPart + '"]');
            if (target) target.replaceChildren.apply(target, Array.from(part.childNodes).map(function (node) { return node.cloneNode(true); }));
          });
          card.dataset.variantId = select.value;
          card.querySelector('[data-ps-variant-select]').value = select.value;
          card.querySelectorAll('[data-ps-variant-link]').forEach(function (link) {
            link.href = template.dataset.url + (link.dataset.psAnchor ? '#' + link.dataset.psAnchor : '');
          });
          var action = card.querySelector('[data-ps-action]');
          if (action) action.textContent = template.dataset.available === 'true' ? card.dataset.availableAction : card.dataset.unavailableAction;
        });
        saveHome(root);
      });

      var params = new URLSearchParams(location.search);
      var returning = params.get('ps_return');
      var saved = returning && readHome();
      selectCategory(root, params.get('ps_category') || (saved && saved.category) || 'bestsellers');
      if (saved && saved.variants) {
        Object.keys(saved.variants).forEach(function (handle) {
          var card = Array.from(root.querySelectorAll('[data-ps-product-grid] [data-product-handle]')).find(function (item) { return item.dataset.productHandle === handle; });
          var select = card && card.querySelector('[data-ps-variant-select]');
          if (!select || !Array.from(select.options).some(function (option) { return option.value === saved.variants[handle]; })) return;
          select.value = saved.variants[handle];
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      function restorePosition() {
        if (returning === 'position' && saved && Number.isFinite(saved.scrollY)) window.scrollTo(0, Math.max(0, saved.scrollY));
        else if (returning === 'shop' || params.has('ps_category')) {
          var shop = root.querySelector('.ps-home__shop');
          if (shop) shop.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }
      if (saved || params.has('ps_category')) {
        if (document.readyState === 'complete') requestAnimationFrame(restorePosition);
        else window.addEventListener('load', restorePosition, { once: true });
      }
      root.addEventListener('click', function (event) {
        var link = event.target.closest('a[href]');
        if (link && new URL(link.href, location.href).origin === location.origin) saveHome(root);
      });
      window.addEventListener('pagehide', function () { saveHome(root); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
